<template>
  <div class="container-fluid px-0">
    <h1 class="page-title letraDelTitulo col-12">CONSULTA DE ABOGADOS REGISTRADOS</h1>
    <br />
    <div class="container-fluid" v-if="cargoNumeroDeAbogados">
      <div class="row d-flex px-lg-5">
          <div id="realizarLaBusquedaDeLosAbogados_div" class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 padding-div-low">
            <div class="area-claro div-principal-BusquedaDeLosAbogados">
              <!-- <h2>Búsqueda</h2> -->
              <div class="alert alert-dark alert-info-BusquedaDeLosAbogados" role="alert">
                <h3 class="alert-heading">Búsqueda</h3>
                <p>La búsqueda se realizará dentro de un listado de <span>{{ numeroAbogadosRegistrados }}</span> abogados registrados</p>
              </div>
              <!-- <hr /> -->
              <div class="form-group">
                <label for="nombreDelAbogado">Nombre(s)</label>
                <input id="nombreDelAbogado" v-model="nombres" class="form-control form-control-claro" placeholder="Nombre(s) del abogado"  @input="(text) => (nombres = nombres.toUpperCase())" @keypress="esLetra($event)" />
              </div>
              <div class="form-group">
                <label for="apellidoPaternoDelAbogado">Primer Apellido</label>
                <input id="apellidoPaternoDelAbogado" v-model="apellidoPaterno" class="form-control form-control-claro" placeholder="Primer apellido del abogado" @input="(text) => (apellidoPaterno = apellidoPaterno.toUpperCase())" @keypress="esLetra($event)" />
              </div>
              <div class="form-group">
                <label for="apellidoMaternoDelAbogado">Segundo Apellido</label>
                <input id="apellidoMaternoDelAbogado" v-model="apellidoMaterno" class="form-control form-control-claro" placeholder="Segundo apellido del abogado"  @input="(text) => (apellidoMaterno = apellidoMaterno.toUpperCase())" @keypress="esLetra($event)" />
              </div>
              <div class="form-group">
                <label>Cédula</label>
                <input id="cedulaDelAbogado" v-model="cedula" class="form-control form-control-claro" placeholder="Cédula del abogado" />
              </div>
              <div class="text-right">
                <button class="btn btn-primary overwrapDeBotones" id="buscarAbogados" v-on:click="obtenLosAbogados()"><i class="fa fa-search"></i>&nbsp;&nbsp;Buscar abogado</button>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-9 padding-div-low">
            <div class="area-claro">
              <h2>Abogados encontrados</h2>
              <h5>Aquí se muestran los abogados encontrados con las condiciones ingresadas</h5>
              <hr />
              <div class="table-responsive" id="tabla_Abogados_div">
                <table class="table table-striped table-light table-hover">
                  <thead class="thead">
                    <tr>
                      <th class="text-center">Cédula</th>
                      <th class="text-center">Nombres</th>
                      <th class="text-center">Apellido paterno</th>
                      <th class="text-center">Apellido materno</th>
                      <th class="text-center">Fecha de registro</th>
                      <th class="text-center">Tipo de cédula</th>
                      <th class="text-center">Vencimiento</th>
                    </tr>
                  </thead>
                  <tbody class="text-dark">
                    <tr v-if="abogados.length <= 0">
                      <td class="text-center" colspan="7">No existen registros de abogados</td>
                    </tr>
                    <tr v-else v-for="(abogado, index) in abogados" :key="abogado.AbogadoId">
                      <td class="text-center">{{abogado.CedulaActiva.Cedula}}</td>
                      <td v-html="obtenElNombreDelAbogado(abogado)" v-bind:colspan="tamañosDeLasColumnas[index]"></td>
                      <td v-if="tamañosDeLasColumnas[index] == 1">{{abogado.ApellidoPaterno}}</td>
                      <td v-if="tamañosDeLasColumnas[index] == 1">{{abogado.ApellidoMaterno}}</td>
                      <td class="text-center" v-html="obtenLaFechaConFormato(abogado.FechaRegistro)"></td>
                      <td class="text-center" v-html="obtenTipoDeCedula(abogado.CedulaActiva.TipoCedula)"></td>
                      <td class="text-center" v-html="obtenLaFechaConFormato(abogado.CedulaActiva.TipoCedula == false ? abogado.CedulaActiva.FechaFinal : null)"></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
      </div>
    </div>
    <br />
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import enumeraciones_sicpo from "@/../static/js/enumeraciones/sicpo.js";
  import catalogos from '@/../static/js/catalogos'
  import api from '@/../static/js/api'
  import comun from '@/../static/js/comun'
  import axios from 'axios'
  import { servicioRestPost } from '../../../Audiencias/Programacion/servicios/ServiciosHttp.js';
  import func from '../../../SIVAC/Comun/Funciones/comun.js'

  export default {
    data() {
      return {
        enumeraciones,
        enumeraciones_sicpo,
        servicioRestPost,
        abogados: [],
        nombres: "",
        apellidoPaterno: "",
        apellidoMaterno: "",
        cedula: "",
        tamañosDeLasColumnas: [],
        nombreDeVariableDelComponente: "cargoPaginaOficial",
        numeroAbogadosRegistrados: 0,
        cargoNumeroDeAbogados: false
      }
    },
    mounted() {
      this.$emit("marcaLaCargaYVerifica", this.nombreDeVariableDelComponente, this.enumeraciones_sicpo.EstadosDeCarga.Cargado);
    },
    async created() {
      await Promise.resolve(this.ejecutarProcesoGetNumeroDeAbogados({ conLoading: false }));
    },
    methods: {
      ejecutarProcesoGetNumeroDeAbogados: async function({ conLoading }) {
          if(conLoading)
              comun.SeEstaCargandoInformacion(true);
          try {
              const PETICION_GET_NUM_ABOGADOS = { EsPrueba: false }
              const { CON_ERROR, RESPUESTA: { numeroAbogadosRegistrados } }  = await Promise.resolve(servicioRestPost({
                  servicioUrl: api.PaginaOficial.funcion.ConsultaDeAbogados.ObtenerNumeroDeAbogadosRegistrados,
                  peticionServicio: PETICION_GET_NUM_ABOGADOS,
                  headers: { TOKEN_AUTORIZACION:this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS: false, HEADER_PARA_ARRAY_BUFFER: false }
              }));

              if(!CON_ERROR) {
                  this.numeroAbogadosRegistrados = numeroAbogadosRegistrados;
              }

              if(conLoading)
                  comun.SeEstaCargandoInformacion(false);
          }
          catch(e) {
              if(conLoading)
                  comun.SeEstaCargandoInformacion(false);
              console.error(e);
          }
          this.cargoNumeroDeAbogados = true;
      },
      obtenLaFechaConFormato: function(fecha) {
        if(fecha != null) 
          return moment(fecha).format("DD/MM/YYYY");// <br /> h:mm a")
        else
          return "";
      },
      obtenElNombreDelAbogado: function(abogado) {
        if(abogado.Nombre == null || abogado.Nombre == undefined) {
          return abogado.NombreMigracion + "<br />(Actualice su información para que sus datos se desplieguen correctamente.)"
        } else {
          return abogado.Nombre
        }
      },
      obtenTipoDeCedula: function(tipoDeCedula) {
        return (tipoDeCedula ? "Profesional" : "Pasante");
      },
      obtenLosAbogados: function() {
        if(this.verificarSiHayInformacionDeAbogado()) {
          comun.SeEstaCargandoInformacion(true, true);

          const parametros = {
            Nombres: this.nombres,
            ApellidoPaterno: this.apellidoPaterno,
            ApellidoMaterno: this.apellidoMaterno,
            Cedula: this.cedula,
            EsPrueba: this.enumeraciones.EsPrueba
          }
         // console.log(api.conexion + api.PaginaOficial.funcion.ConsultaDeAbogados.ObtenAbogadosRegistrados);

          axios.post(
            api.conexion + api.PaginaOficial.funcion.ConsultaDeAbogados.ObtenAbogadosRegistrados,
            parametros
            ).then(async (respuesta) => {
              if(respuesta.data.SiHayError){
                console.log(respuesta);
                comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
              } else {
                this.tamañosDeLasColumnas = [];
                respuesta.data.Abogados.forEach(this.cargaLosTamañosDeLaColumna);
                this.abogados = respuesta.data.Abogados;
                if(this.abogados.length>15){
                  this.$nextTick(()=> { PaginarTabla('tabla_Abogados_div', 10)});
                }
                else
                {
                  $('#navtabla_Abogados_div').remove();
                }
                
              }
              await Promise.resolve(this.ejecutarProcesoGetNumeroDeAbogados({ conLoading: false }));
              comun.SeEstaCargandoInformacion(false, true);
            }
            ).catch(excepcion => {
              console.log(excepcion);
              comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
              comun.SeEstaCargandoInformacion(false, true);
            })
        }
      },
      cargaLosTamañosDeLaColumna: function(abogado, indice) {
        if(abogado.Nombre == null || abogado.Nombre == undefined)
          this.tamañosDeLasColumnas.push(3);
        else 
          this.tamañosDeLasColumnas.push(1);
      },
      verificarSiHayInformacionDeAbogado: function() {
        if((this.nombres === "" || this.nombres == null) &&
          (this.apellidoPaterno === "" || this.apellidoPaterno == null) &&
          (this.apellidoMaterno === "" || this.apellidoMaterno == null) &&
          (this.cedula === "" || this.cedula == null)) {
          comun.mensajeDeAlerta("Ingrese algún dato para poder realizar la búsqueda de los abogados.", null, null);
          return false;
        }

        return true;
      },
      esLetra(datos){
        return func.esLetra(datos)
      },
    }
  }
</script>

<style scoped>
  .page-title {
    background-color: rgb(0,117,115);
    color: #FFF;
    padding: 2vh 20vw;
  }

  .div-principal-BusquedaDeLosAbogados .alert-dark {
    color: white;
    background-color: #545757;
    border-color: #c6c8ca;
  }

  .alert-info-BusquedaDeLosAbogados p > span {
    font-weight: 900;
    font-size: 1.3em;
  }

  @media(max-width: 991px) {
    #realizarLaBusquedaDeLosAbogados_div {
      padding-top: 0;
      padding-bottom: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/PaginaOficial/Funciones/ConsultaDeAbogados/ConsultaDeAbogados.vue